import { render, staticRenderFns } from "./DirectionDetail.vue?vue&type=template&id=06270edc&scoped=true&"
import script from "./DirectionDetail.vue?vue&type=script&lang=js&"
export * from "./DirectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./DirectionDetail.vue?vue&type=style&index=0&id=06270edc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06270edc",
  null
  
)

export default component.exports